export enum AuthenticationType {
  UsernamePassword = 0,
  LDAP = 1
}
